import { typography } from '@/designSystem/index';
import styled from 'styled-components';

export const Description = styled.p`
  ${typography.sm};
  padding: 20px 8px;
`;
